
document.addEventListener( 'DOMContentLoaded', function () {
    // Dynamically select fields based on the "postcode_{formid}*" class
    const formId = document.querySelector( '.gform_wrapper form' )?.getAttribute( 'data-formid' );
    if ( formId ) {
        const postcodeDivs = document.querySelectorAll( `form [class*="postcode-${formId}"]` );

        const fields = {};
        postcodeDivs.forEach( ( node ) => {
            // Extract the class after 'postcode-'
            const className = Array.from( node.classList ).find( cls => cls.startsWith( `postcode-${formId}-` ) );
            if ( className ) {
                const key = className.replace( `postcode-${formId}-`, '' ); // Remove 'postcode_' prefix
                fields[key] = node; // Assign the node to the object with the extracted key
            }
        });

        // Assign specific fields from the dynamically created variables
        const sourcefieldCity = fields.city; // Target field for the postal code
        const sourcefieldStreet = fields.street; // Target field for the postal code
        const sourcefieldHouseNumber = fields.house_number; // Target field for the postal code
        const sourcefieldHouseNumberAddon = fields.house_number_addon; // Target field for the postal code
        const sourcefieldPostcode = fields.postcode; // Target field for the postal code
        
        
        // Check if all necessary fields exist in the DOM

        if ( sourcefieldCity && sourcefieldStreet && sourcefieldHouseNumber && sourcefieldHouseNumberAddon && sourcefieldPostcode ) {
            let debounceTimeout;
            const updateTargetField = () => {
                const postcodeValue = sourcefieldPostcode.value.trim();
                const houseNumberValue = sourcefieldHouseNumber.value.trim();
                const houseNumberAddonValue = sourcefieldHouseNumberAddon.value.trim();

                /**
                 * @update
                *  integrate houseNumberAddonValue
                 */

                // Clear any existing timeout
                clearTimeout( debounceTimeout );

                // Set a new timeout for 1 seconds
                debounceTimeout = setTimeout( async () => {
                    if ( postcodeValue && houseNumberValue ) {
                        var address = await autoFillAddress( postcodeValue, houseNumberValue );

                        if ( address ) {
                            sourcefieldStreet.value = address?.street;
                            sourcefieldCity.value = address?.city;
                        }
                    }
                }, 1000 );
            };

            // Attach the input event listener to the dynamically selected fields
            sourcefieldHouseNumber.addEventListener( 'input', updateTargetField );
            sourcefieldHouseNumberAddon.addEventListener( 'input', updateTargetField );
            sourcefieldPostcode.addEventListener( 'input', updateTargetField );
        }
    }
} );
